import Vue from 'vue';
import {
    Notify,
    Button,
    Toast,
    Swipe,
    SwipeItem,
    Dialog
} from 'vant';
import 'vant/lib/index.css';

Vue.use(Notify);
Vue.use(Button);
Vue.use(Toast);
Vue.use(Swipe).use(SwipeItem).use(Dialog);